import { render, staticRenderFns } from "./ordersStatus.vue?vue&type=template&id=6e301516&"
import script from "./ordersStatus.vue?vue&type=script&lang=js&"
export * from "./ordersStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports